import React from 'react'
import { BButton, BTitle, BLink } from '@prague-digi/ui-components'
import { compose } from 'recompose'
import { connect, ConnectedProps } from 'react-redux'
import { push } from 'connected-react-router'

import messages from '../../i18n'
import { intl, IntlInterface, form, FormInterface } from '../../hoc'
import { ReduxState } from '../../types'
import { SmsVerifyError } from '../../constants'
import { appActions, clientActions, modalDialogActions } from '../../redux'
import { BTextInput, mapResponseToErrorResponse, SmsError } from '../../components/'
import { getReturnRoute } from '../../utils/wizard'
import CacheSmsNotification from './CacheSmsNotification'
import validate from './CacheAuthDialog.validate'
import styles from './styles.scss'
import sms from '../../assets/sms.svg'

type ReduxProps = ConnectedProps<typeof connector>

type Props = IntlInterface & FormInterface & ReduxProps

export class CacheAuthDialog extends React.Component<Props> {
  onSubmit = () => {
    this.props.handleSubmit(this.verifyCode)()
  }

  verifyCode = () => {
    const { verifyCacheSmsCode, translate } = this.props

    verifyCacheSmsCode({
      success: (target: number) => {
        this.props.setAppReady()
        this.props.hideModalDialog('CACHE_AUTH')
        this.props.push(getReturnRoute(target))
      },
      error: () =>
        this.props.setErrors('CacheAuth', {
          smsCode: translate(messages.recapitulation.footer.sendSmsErrorInvalid),
        }),
    })
  }

  renderError = (errorResponse: SmsVerifyError | undefined) => {
    const { cacheSmsSendResponse, change, translate, resendCacheSmsCode } = this.props

    change('smsCode', '')

    return (
      <SmsError
        nextAttemptAvailable={cacheSmsSendResponse?.nextAttemptAvailable}
        sendSms={resendCacheSmsCode}
        translate={translate}
        variant={errorResponse as SmsVerifyError}
      />
    )
  }

  renderContent = () => {
    const { cacheSmsSendResponse, phoneNumber, translate, resendCacheSmsCode } = this.props

    return (
      cacheSmsSendResponse && (
        <div>
          <img src={sms} alt="" className={styles.cover} />
          <BTitle type="h3" center>
            {translate(messages.SaveAndReturn.smsCodeTitle)}
          </BTitle>
          <CacheSmsNotification
            cacheSmsStatus={cacheSmsSendResponse.sent}
            phoneNumber={phoneNumber}
          />
          <div className={styles.footer}>
            <div className={styles.smsCodeEntry}>
              <BTextInput
                autoFocus
                messages={{
                  label: translate(messages.SaveAndReturn.smsCode),
                }}
                name="smsCode"
                testid="smsCode"
              />
            </div>
            <BButton
              testid="continueBtn"
              messages={{ message: translate(messages.common.continue) }}
              color="primary"
              onClick={this.onSubmit}
              theme={styles.btn}
            />
          </div>
          {cacheSmsSendResponse.nextAttemptAvailable && (
            <div className={styles.smsCodeHandler}>
              <BLink onClick={resendCacheSmsCode} testid="resendSmsLink" theme={styles.link}>
                {translate(messages.SaveAndReturn.sendAgain)}
              </BLink>
            </div>
          )}
        </div>
      )
    )
  }

  render() {
    const { cacheVerifySmsStatus } = this.props
    const errorResponse = mapResponseToErrorResponse(cacheVerifySmsStatus)

    return <>{errorResponse ? this.renderError(errorResponse) : this.renderContent()}</>
  }
}

const connector = connect(
  (state: ReduxState) => ({
    cacheSmsSendResponse: state.client.cacheSmsSendResponse,
    cacheVerifySmsStatus: state.client.cacheVerifySmsStatus,
  }),
  {
    hideModalDialog: modalDialogActions.hideModalDialog,
    push,
    resendCacheSmsCode: clientActions.resendCacheSmsCode,
    setAppReady: appActions.setAppReady,
    showModalDialog: modalDialogActions.showModalDialog,
    verifyCacheSmsCode: clientActions.verifyCacheSmsCode,
  }
)

export default compose(
  connector,
  form({
    name: 'CacheAuth',
    validate,
  }),
  intl
)(CacheAuthDialog)
